// extracted by mini-css-extract-plugin
export var checkbox = "_7z-0";
export var circle = "_7z-3";
export var horizontalContainer = "_7z-7";
export var sm = "_7z-5";
export var switch0 = "_7z-2";
export var switchDisabled = "_7z-8";
export var switchEnabled = "_7z-1";
export var textSwitchContainer = "_7z-9";
export var textSwitchOption = "_7z-a";
export var textSwitchOptionSelected = "_7z-b";
export var verticalContainer = "_7z-6";
export var xs = "_7z-4";